import { useKitbagAuth } from '@statsbomb/kitbag-auth';
import { Checkbox, Table } from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

export function QACheckConfirmation({
  preventApproval,
  setVideoInformationIsCorrect,
  setVideoQualityIsCorrect,
  videoInformationIsCorrect,
  videoQualityIsCorrect,
}) {
  const [approvingUserEmail, setEmail] = useState();

  const { getIdTokenClaims } = useKitbagAuth();

  useEffect(() => {
    async function getEmail() {
      const { email } = await getIdTokenClaims();
      setEmail(email);
    }
    getEmail();
  }, []);

  return (
    <Table>
      <Table.Head>
        <Table.HeaderCell colSpan={2}>
          <FormattedMessage
            defaultMessage="Certified by {user}"
            id="885d1"
            values={{ user: approvingUserEmail }}
          />
        </Table.HeaderCell>
      </Table.Head>
      <Table.Body>
        <Table.Row>
          <Table.DataCell $textAlign="left">
            <FormattedMessage
              defaultMessage="Match Data Is Correct"
              id="62f43"
            />
          </Table.DataCell>
          <Table.DataCell $textAlign="left">
            <Checkbox
              checked={videoInformationIsCorrect}
              disabled={preventApproval}
              id="approve-video-info"
              onChange={() =>
                setVideoInformationIsCorrect((currentValue) => !currentValue)
              }
              size="small"
            />
          </Table.DataCell>
        </Table.Row>
        <Table.Row>
          <Table.DataCell $textAlign="left">
            <FormattedMessage
              defaultMessage="Technical Data Is Suitable"
              id="56919"
            />
          </Table.DataCell>
          <Table.DataCell $textAlign="left">
            <Checkbox
              checked={videoQualityIsCorrect}
              disabled={preventApproval}
              id="approve-video-quality"
              onChange={() =>
                setVideoQualityIsCorrect((currentValue) => !currentValue)
              }
              size="small"
            />
          </Table.DataCell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
}

QACheckConfirmation.propTypes = {
  preventApproval: PropTypes.bool.isRequired,
  setVideoInformationIsCorrect: PropTypes.func.isRequired,
  setVideoQualityIsCorrect: PropTypes.func.isRequired,
  videoInformationIsCorrect: PropTypes.bool.isRequired,
  videoQualityIsCorrect: PropTypes.bool.isRequired,
};

export default { QACheckConfirmation };
